import { IconSearch } from "@tabler/icons-react";
import type { FC } from "react";
import { Input, SearchField } from "react-aria-components";
import { SearchInputStyle } from "../Inputs/searchInputStyle.js";
import { Loader, LoaderStyle } from "../Loader/loader.js";
import { menuStyle } from "./menuStyle.js";

export interface MenuSearchFieldProps {
  /** Accessible label for the field, such as "Search values". */
  "aria-label": string;
  placeholder?: string;
  maxLength?: number;
  /** Shows a spinner beside the field while matching options are loading. */
  isLoading?: boolean;
}

/**
 * Search field pinned above a menu's scrolling options, separated from them by
 * a rule. Carries the padding the options get from their scroll container, so
 * the two line up.
 */
export const MenuSearchField: FC<MenuSearchFieldProps> = (props) => (
  <div className="shrink-0 px-1 pt-1">
    <SearchInputStyle />

    <div className="flex items-center gap-2 px-2 py-1.5">
      <IconSearch className="size-4 shrink-0 text-muted-foreground" />

      <SearchField aria-label={props["aria-label"]} className="min-w-0 flex-1">
        <Input
          maxLength={props.maxLength}
          placeholder={props.placeholder}
          className="w-full border-0 bg-transparent p-0 text-sm text-foreground shadow-none ring-0 outline-hidden placeholder:text-muted-foreground"
        />
      </SearchField>

      {props.isLoading ? (
        <Loader
          style={LoaderStyle.SPINNER}
          // The spinner is spaced for sitting inline with text, which lifts it
          // off this row's centre line.
          className="mx-0 mb-0 size-3.5 shrink-0"
        />
      ) : null}
    </div>

    {/* The options' scroll container supplies the space below the rule. */}
    <div className={menuStyle().separator({ className: "mb-0" })} />
  </div>
);
